import { tryQuery } from 'src/utils/queries'
import { bidlClient } from 'src/utils/api'

const baseUri = '/api/trade'

export type UpdateLocationConfigurationRequest = {
  update: {
    locationId: string
    configurations: KeyValuePair[]
  }
}

export type UpdateSalesSeriesConfigurationRequest = {
  updates: {
    salesSeriesId: string
    configurations: KeyValuePair[]
  }
}

export type DeleteLocationConfigurationRequest = {
  id: string
}

export function FindAllLocationConfigurationsForTenant({ tenantId, continuationToken, pageSize }) {
  return tryQuery(
    bidlClient.post(
      `${baseUri}/config/v1/operation/FindAllLocationConfigurationsForTenant`,
      {
        pagination: {
          pageSize,
          token: continuationToken,
        },
      },
      {
        headers: {
          'X-Bushel-Tenant': tenantId,
        },
      }
    )
  )
}

export function FindAllSalesSeriesConfigurationsForTenant({
  tenantId,
  continuationToken,
  pageSize,
}) {
  return tryQuery(
    bidlClient.post(
      `${baseUri}/config/v1/operation/FindAllSalesSeriesConfigurationsForTenant`,
      {
        pagination: {
          pageSize,
          token: continuationToken,
        },
      },
      {
        headers: {
          'X-Bushel-Tenant': tenantId,
        },
      }
    )
  )
}

export function GetLocationConfigurables(tenantId: string) {
  return tryQuery(
    bidlClient.post(
      `${baseUri}/config/v1/operation/GetLocationConfigurables`,
      {},
      {
        headers: {
          'X-Bushel-Tenant': tenantId,
        },
      }
    )
  )
}

export function GetSalesSeriesConfigurables(tenantId: string) {
  return tryQuery(
    bidlClient.post(
      `${baseUri}/config/v1/operation/GetSalesSeriesConfigurables`,
      {},
      {
        headers: {
          'X-Bushel-Tenant': tenantId,
        },
      }
    )
  )
}

export function FindOrCreateLocationConfiguration({
  tenantId,
  locationId,
}: {
  tenantId: string
  locationId: string
}) {
  return tryQuery(
    bidlClient.post(
      `${baseUri}/config/v1/operation/FindOrCreateLocationConfiguration`,
      {
        id: locationId,
      },
      {
        headers: {
          'X-Bushel-Tenant': tenantId,
        },
      }
    )
  )
}

export function FindOrCreateSalesSeriesConfiguration({
  tenantId,
  salesSeriesId,
}: {
  tenantId: string
  salesSeriesId: string
}) {
  return tryQuery(
    bidlClient.post(
      `${baseUri}/config/v1/operation/FindOrCreateSalesSeriesConfiguration`,
      {
        id: salesSeriesId,
      },
      {
        headers: {
          'X-Bushel-Tenant': tenantId,
        },
      }
    )
  )
}

export function UpdateLocationConfiguration(
  data: UpdateLocationConfigurationRequest,
  tenantId: string
) {
  return tryQuery(
    bidlClient.post(
      `${baseUri}/config/v1/operation/UpdateLocationConfiguration`,
      JSON.stringify(data),
      {
        headers: {
          'X-Bushel-Tenant': tenantId,
          'Content-Type': 'application/json',
        },
      }
    )
  )
}

export function DeleteLocationConfiguration(
  data: DeleteLocationConfigurationRequest,
  tenantId: string
) {
  return tryQuery(
    bidlClient.post(`${baseUri}/config/v1/operation/DeleteLocationConfiguration`, data, {
      headers: {
        'X-Bushel-Tenant': tenantId,
        'Content-Type': 'application/json',
      },
    })
  )
}

export function UpdateSalesSeriesConfiguration(
  data: UpdateSalesSeriesConfigurationRequest,
  tenantId: string
) {
  return tryQuery(
    bidlClient.post(
      `${baseUri}/config/v1/operation/UpdateSalesSeriesConfiguration`,
      JSON.stringify(data),
      {
        headers: {
          'X-Bushel-Tenant': tenantId,
          'Content-Type': 'application/json',
        },
      }
    )
  )
}
